module.exports = __webpack_public_path__ + "img/close-modal.f7ee093d.svg";